import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../api";
import { AttendanceLocalGuiche } from "../../../../@types/attendance-local-guiche";
import { AxiosError } from "axios";

export type AttendanceLocalGuicheCreateData = Pick<
    AttendanceLocalGuiche,
    | "ordem"
    | "tipo"
    | "ativo"
    | "unidade"
> & {
    users: Array<string>
};

export function useAttendanceLocalGuicheCreate() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "guiche", "create"],
        mutationFn: async (data: AttendanceLocalGuicheCreateData) => {
            const response = await apisiseci.post<AttendanceLocalGuiche>(
                '/cms/guiche_unidade/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Guichê criado com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ["attendance-local", "guiche", "list"],
            });
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
